import React, { useState, useEffect } from "react";
import {
  DialogContent,
  DialogTitle,
  Dialog,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Link,
  Grid,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import Loader from "../../components/Loader";
import { makeStyles } from "@material-ui/core/styles";
import { default as iqsim_api } from "./../../apis/iqsim";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));
const ChangePortGroup = (props) => {
  const classes = useStyles();
  const [portGroups, setPortGroups] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);
  const { onClose, open, deviceId: device_id} = props;
  const [message,setMessage]= useState(undefined);


  const changePortGroup = () => {
    console.log(device_id);
    let data = {name:selectedPlan};
    console.log(data);
    setLoading(true);
    iqsim_api
      .post(
        `/device/${device_id}/change-port-group`,
        data
      )
      .then(({ data }) => {
        console.log(data);
        if (data.success) {
          setMessage("New Port Group Activated.");
        }
      })
      .catch((error) => {
        // console.log(error.response.data);
        setError("Error Occurred, Please retry !");
      })
      .finally(() => {
        setLoading(false);
      });
  };


  const fetchPortGroups= () => {
    setLoading(true);
    setMessage(undefined);
    iqsim_api
      .get(`/port-groups`)
      .then(({ data }) => {
        console.log(data);
        setPortGroups(data);
      })
      .catch((error) => {
        // console.log(error.response.data);
        setError("Error Occurred, Please retry !");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    console.log(device_id);
    if (device_id && device_id !== null) {
      fetchPortGroups();
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [device_id]);

  if (loading) {
    return <Loader />;
  } else {
    return (
      <React.Fragment>
        <Dialog
          onClose={onClose}
          open={open}
          aria-labelledby="simple-dialog-title"
          fullWidth={false}
          maxWidth={"lg"}
        >
          <DialogTitle id="simple-dialog-title">
           Change Port Group For {device_id}
          </DialogTitle>
          <DialogContent>
            {error && (
              <Box pt={3}>
                <Alert severity="error"> {error} </Alert>
              </Box>
            )}

            {message && (
              <Box pt={3}>
                <Alert severity="success"> {message} </Alert>
              </Box>
            )}
            {portGroups && (
              <Box pt={3} pb={3}>
                <Grid
                  container
                  direction="column"
                  justify="flex-start"
                  alignItems="flex-start"
                  spacing={2}
                >
                  <Grid item>
                    <FormControl className={classes.formControl}>
                      <InputLabel id="select-plan">Select Port Group</InputLabel>
                      <Select
                        labelId="select-plan"
                        id="plan"
                        value={selectedPlan}
                        onChange={(e) => setSelectedPlan(e.target.value)}
                      >
                        {portGroups.map((plan, index) => (
                          <MenuItem value={plan.name} key={index}>
                            {plan.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="secondary"
                      component={Link}
                      onClick={() => {
                        changePortGroup();
                      }}
                    >
                      Change Port Group
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            )}
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
};

export default ChangePortGroup;
